export default "__VITE_ASSET__CeChp56e__"